import camelize from "camelize";
import dasherize from "dasherize";

export default function getStylePropertyValue(element, propertyName) {
  let value;

  if(document.defaultView && document.defaultView.getComputedStyle) {
    value = document.defaultView.getComputedStyle(element, "").getPropertyValue(dasherize(propertyName));
  } else {
    value = element.currentStyle[camelize(propertyName)];
  }

  // Return a numeric value for every property value that looks like a number
  return (value && value.match(/^[\d.]+(px)?/)) ? parseFloat(value, 10) : value;
}
